(function(){
'use strict';
var doc = document, W = window;

/* Beim Oeffnen und beim Neuladen immer oben anfangen. Browser stellen sonst
   die letzte Scrollposition wieder her — hinter dem Gate landet man dann
   mitten in der Seite, und auf dem Handy sieht das nach einem Fehler aus. */
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
if (!location.hash) {
  W.scrollTo(0, 0);
  W.addEventListener('load', function(){ if (!location.hash) W.scrollTo(0, 0); });
}
var flau = W.matchMedia('(prefers-reduced-motion:reduce)').matches;
var $  = function(s,k){ return (k||doc).querySelector(s); };
var $$ = function(s,k){ return Array.prototype.slice.call((k||doc).querySelectorAll(s)); };

/* ====================== Öffnungszeiten =========================
   Mo–Fr 10–19, Sa 9–14, So zu. Quelle: Google-Eintrag, deckt sich
   mit der bisherigen Seite. Der Satz „die ganze Woche durchgehend
   geöffnet" meint durchgehend ohne Mittagspause, nicht sieben Tage. */
var ZEITEN = [null,[10,19],[10,19],[10,19],[10,19],[10,19],[9,14]];
var TAGE = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];

function statusText(){
  var d = new Date(), t = d.getDay(), m = d.getHours()*60 + d.getMinutes(), z = ZEITEN[t];
  if(z && m >= z[0]*60 && m < z[1]*60){
    var bis = z[1]*60 - m;
    return {auf:true, text: bis <= 60
      ? 'Noch ' + bis + ' Minuten geöffnet'
      : 'Jetzt geöffnet · bis ' + z[1] + ':00 Uhr'};
  }
  if(z && m < z[0]*60) return {auf:false, text:'Heute ab ' + z[0] + ':00 Uhr geöffnet'};
  for(var i=1;i<=7;i++){
    var n = (t+i) % 7, zz = ZEITEN[n];
    if(zz) return {auf:false, text:(i===1?'Morgen':TAGE[n]) + ' ab ' + zz[0] + ':00 Uhr'};
  }
  return {auf:false, text:'Öffnungszeiten siehe unten'};
}
function statusSetzen(){
  var s = statusText();
  $$('[data-status]').forEach(function(el){
    el.classList.toggle('zu', !s.auf);
    var t = $('.txt-status', el);
    if(t) t.textContent = s.text;
  });
}

/* ====================== Warenkorb ==============================
   Der Warenkorb liegt jetzt bei Shopify, nicht mehr im Browserspeicher.
   huette-shop.js hält W.KORB_ANZAHL aktuell und ruft korbBadge(). */
function korbAnzahl(){ return W.KORB_ANZAHL || 0; }
function korbBadge(){
  var b = $('#korb-zahl'), n = korbAnzahl();
  if(!b) return;
  b.textContent = n;
  b.classList.toggle('an', n > 0);

  /* Der Knopf heisst jetzt in der Vorlage schon "Warenkorb" und fuehrt auch
     dorthin — das Sortiment steht als eigener Punkt in der Navigation. Frueher
     stand hier "Shop" und das Script tauschte die Beschriftung, sobald etwas
     im Korb lag; dabei ueberschrieb es die Beschriftung aus der Vorlage.
     Geblieben ist nur, was von der Anzahl abhaengt: die Schublade und die
     Vorlesehilfe. */
  [$('#korb-knopf')].forEach(function(k){
    if(!k) return;
    if(n > 0){
      k.setAttribute('data-korb-auf', '');
      k.setAttribute('aria-label', 'Warenkorb öffnen, ' + n + ' Artikel');
    } else {
      k.removeAttribute('data-korb-auf');
      k.setAttribute('aria-label', 'Warenkorb, leer');
    }
  });
}
W.HUETTE = { anzahl:korbAnzahl, badge:korbBadge };

/* ====================== Überschriften umbrechen =================
   Von Hand gesetzte Umbrüche stimmen nur bei einer Breite; bei jeder
   anderen schiebt die Aufsteig-Animation halbe Zeilen durchs Bild.
   Deshalb misst das Script nach dem Layout selbst — und erneut,
   sobald die Schriften geladen sind. */
/* Der Messspan lag frueher IM Element, und das Element wurde vorher geleert.
   Jede Breitenmessung hat damit das Layout der ganzen Seite neu rechnen
   lassen — einmal pro Wort, plus bis zu vierzehn Durchlaeufe der
   Verkleinerung. Auf schmalen Schirmen kostete das gemessene 366 ms
   Hauptthread beim Laden (auf dem Desktop 0, weil die Layoutberechnung dort
   billiger ist).

   Jetzt steht der Span in einem eigenen Kasten mit contain:strict. Was
   darin passiert, bleibt darin: die Messungen loesen kein Layout der Seite
   mehr aus. Und das Element wird erst NACH dem Messen geleert, damit
   waehrend der Messung ueberhaupt nichts schmutzig ist.

   Gemessen wird unveraendert per DOM mit derselben Schrift und Sperrung —
   die Umbrueche muessen dieselben bleiben. */
var messKasten = null, messSpan = null;
function messer(){
  if(messSpan) return messSpan;
  messKasten = doc.createElement('div');
  messKasten.setAttribute('aria-hidden', 'true');
  messKasten.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;' +
    'height:1px;overflow:hidden;contain:strict;pointer-events:none';
  messSpan = doc.createElement('span');
  messSpan.style.cssText = 'position:absolute;left:0;top:0;white-space:nowrap';
  messKasten.appendChild(messSpan);
  doc.body.appendChild(messKasten);
  return messSpan;
}
function zeilenTeilen(el){
  var roh = el.getAttribute('data-roh');
  if(roh == null){ roh = el.textContent.trim(); el.setAttribute('data-roh', roh); }
  var worte = roh.split(/\s+/);
  var mess = messer();
  var stil = getComputedStyle(el);
  mess.style.font = stil.font;
  mess.style.letterSpacing = stil.letterSpacing;
  var platz = el.clientWidth;
  if(!platz){ el.textContent = roh; return; }

  var zeilen = umbruchRechnen(worte, mess, platz);

  /* Passt ein einzelnes Wort selbst allein nicht in die Zeile, wird die
     Überschrift schrittweise verkleinert statt überzulaufen. */
  var gr = parseFloat(stil.fontSize), schutz = 0;
  while(schutz++ < 14){
    var zu = false;
    for(var j=0;j<zeilen.length;j++){
      mess.textContent = zeilen[j];
      if(mess.offsetWidth > platz + 1){ zu = true; break; }
    }
    if(!zu) break;
    gr *= 0.94;
    el.style.fontSize = gr + 'px';
    mess.style.fontSize = gr + 'px';
  }
  el.textContent = '';
  zeilen.forEach(function(z){
    var s = doc.createElement('span'); s.className = 'zl';
    var i2 = doc.createElement('i'); i2.textContent = z;
    s.appendChild(i2); el.appendChild(s);
  });
}
function alleTeilen(){ $$('.teil').forEach(zeilenTeilen); }

/* Der reine Umbruch, ohne das Dokument anzufassen. Wird zweimal gebraucht:
   beim Teilen selbst und beim Vergleich, ob nach dem Laden der Hausschrift
   ueberhaupt neu geteilt werden muss. */
function umbruchRechnen(worte, mess, platz){
  var zeilen = [], akt = '';
  for(var i=0;i<worte.length;i++){
    var probe = akt ? akt + ' ' + worte[i] : worte[i];
    mess.textContent = probe;
    if(mess.offsetWidth > platz && akt){ zeilen.push(akt); akt = worte[i]; }
    else akt = probe;
  }
  if(akt) zeilen.push(akt);
  return zeilen;
}

/* Wuerde die Hausschrift eine ANDERE Zeilenaufteilung ergeben als die, die
   gerade steht? Nur dann lohnt das Neuteilen.

   Warum das wichtig ist: neuTeilen schaltet fuer seine Dauer alle
   Uebergaenge ab. Faellt es mitten in die Einlauf-Animation der
   Ueberschrift, bricht es sie ab und die Zeile springt auf ihren Platz.
   Genau das passiert bei gecachter Schrift — also bei jedem Wiederkehrer,
   und damit im Normalfall. Ohne diese Pruefung lief die Animation nur
   beim allerersten Besuch sauber durch. */
/* Welche Ueberschriften brechen mit der geladenen Hausschrift anders um als
   mit der massgleichen Ersatzschrift?

   Frueher war das eine Ja/Nein-Frage, und ein einziges Ja liess ALLE
   Ueberschriften neu aufbauen — auf der Startseite 13 Stueck. Betroffen ist
   typischerweise genau eine. Das Neubauen kostet je Ueberschrift eine
   erzwungene Layoutrechnung und lief kurz nach dem Ankommen; auf einem
   langsamen Geraet war das die Stockung, die man beim Oeffnen sah. */
function umbruchAbweichler(){
  var mess = messer(), raus = [];
  $$('.teil').forEach(function(el){
    var roh = el.getAttribute('data-roh');
    if(roh == null) return;
    var platz = el.clientWidth;
    if(!platz) return;
    var stil = getComputedStyle(el);
    mess.style.font = stil.font;
    mess.style.letterSpacing = stil.letterSpacing;
    var soll = umbruchRechnen(roh.split(/\s+/), mess, platz);
    var ist = $$('.zl>i', el).map(function(x){ return x.textContent; });
    if(soll.length !== ist.length || soll.join('|') !== ist.join('|')) raus.push(el);
  });
  return raus;
}

/* Neu teilen nach Drehen oder Breitenwechsel — und zwar UNSICHTBAR.
   zeilenTeilen leert die Ueberschrift und baut die Zeilen frisch auf; ohne
   abgeschaltete Uebergaenge faehrt sie dabei jedes Mal neu ein. Das ist
   das Aufploppen, das man beim Scrollen auf dem Handy gesehen hat. */
/* Ohne Argument werden alle Ueberschriften neu geteilt (Drehen,
   Breitenwechsel — dort aendert sich der Umbruch ueberall). Mit einer Liste
   nur diese; so kostet das Nachziehen nach dem Schriftladen nur das, was
   sich wirklich geaendert hat. */
function neuTeilen(welche){
  var wurzel = doc.documentElement;
  var ziele = (welche && welche.length) ? welche : $$('.teil');
  /* Merken, welche Ueberschriften schon aufgedeckt WAREN. Vorher bekamen
     nach dem Neuteilen ALLE ihr .on zurueck — auch die weiter unten, die
     noch niemand gesehen hatte. Sie standen dann fertig da und fuhren beim
     Hinunterscrollen nicht mehr ein. */
  var warOffen = ziele.map(function(t){
    return $$('.zl', t).some(function(z){ return z.classList.contains('on'); });
  });
  revBereit = true;
  wurzel.classList.add('ohne-uebergang');
  ziele.forEach(zeilenTeilen);
  ziele.forEach(function(t, i){
    if(warOffen[i]) $$('.zl', t).forEach(function(z){
      /* `fertig` neben `on`: setzt den Endzustand ohne Animation. Sonst
         startet die Einlauf-Animation neu, sobald die Uebergangssperre
         faellt — die Zeile faellt sichtbar zurueck und faehrt erneut ein. */
      z.classList.add('on'); z.classList.add('fertig');
    });
  });
  /* Layout erzwingen, damit die Sperre wirklich auf den fertigen Zustand
     wirkt, bevor sie wieder faellt. */
  void wurzel.offsetHeight;
  wurzel.classList.remove('ohne-uebergang');
  autoEinblenden(); grosseZerlegen(); revSammeln(); revPruefen();
}

/* ====================== Reveals ================================
   Am Scroll-Handler mit synchronem Initial-Sweep, NICHT am
   IntersectionObserver: hohe Sektionen erreichen eine Prozentschwelle
   nie und blieben sonst dauerhaft unsichtbar. */
var revEls = [];
/* Nichts wird aufgedeckt, bevor die Ueberschriften geteilt sind.

   Vorher erschienen Ueberzeile und Anriss sofort (gemessen 113 ms), die
   Ueberschrift aber erst nach dem Laden der Schrift (2150 ms) — ueber zwei
   Sekunden Abstand. Das las sich als zweites Aufploppen, besonders beim
   Wechsel auf eine Unterseite.

   Jetzt gilt ein Takt: alles zusammen, sobald die Ueberschrift steht.
   Der Riegel faellt spaetestens nach 1,2 s, auch wenn keine Schrift
   antwortet — er kann also nicht dauerhaft klemmen. */
var revBereit = false;
/* Wann die Einlauf-Animation begonnen hat und wie lange sie dauert — das
   Nachschaerfen der Zeilen darf nicht hineinfallen. Der Wert entspricht der
   transition-Dauer von .zl>i in huette-base.css. */
var introZeit = 0;
var INTRO_MS = 700;
function jetzt(){
  return (W.performance && W.performance.now) ? W.performance.now() : Date.now();
}
/* Hat der Browser schon Inhalt gemalt, als das Skript loslegt?

   Davon haengt ab, ob die Ueberschrift einlaufen darf. War noch nichts zu
   sehen, war auch die Ueberschrift nicht zu sehen — die Animation ist dann
   der erste Eindruck und richtig. Stand die Seite dagegen schon da, wuerde
   ein Einlaufen bedeuten, dass die Ueberschrift erst verschwindet und dann
   wiederkommt. Dann wird still geteilt. */
function schonSichtbar(){
  try {
    var p = W.performance.getEntriesByType('paint');
    for (var i = 0; i < p.length; i++) {
      if (p[i].name === 'first-contentful-paint') return true;
    }
  } catch (e) {}
  /* Kennt der Browser die Malzeiten nicht, entscheidet die Uhr: nach einer
     Viertelsekunde ist mit Sicherheit etwas zu sehen. */
  return jetzt() > 250;
}
/* Grosse Bloecke auf dem Handy in ihre Teile zerlegen.

   Eine Einblendung startet, sobald die OBERKANTE ihres Elements ins Bild
   ragt. Auf dem Desktop ist so ein Textblock etwa einen halben Schirm
   hoch, das passt. Auf dem Handy sind dieselben Bloecke 55 bis 162 % der
   Schirmhoehe — das Preisblatt der Leistungsseite misst 1384 px auf einem
   852-px-Schirm. Der ganze Block ist dann fertig eingeblendet, bevor man
   seine untere Haelfte ueberhaupt gesehen hat: man scrollt durch stehenden
   Inhalt und nimmt gar keine Bewegung wahr.

   Deshalb bekommen solche Bloecke hier ihre Kinder als eigene Reveals.
   Jedes faengt an, wenn es selbst ins Bild kommt. Der Block selbst wird
   sichtbar geschaltet — sonst laege seine Deckkraft 0 ueber allen Kindern
   und keines waere zu sehen.

   Ausgenommen: Bloecke mit nur einem Kind (da gibt es nichts zu staffeln),
   `figure` (Bild und Bildunterschrift getrennt einzublenden sieht nach
   Fehler aus) und Ueberschriften mit `.teil` — die haben mit dem
   zeilenweisen Aufsteigen schon ihre eigene Bewegung. */
function grosseZerlegen(){
  if(W.innerWidth > 699) return;
  var h = W.innerHeight, fund = [];
  /* Erst messen, dann schreiben. Klassen zwischen den Messungen zu setzen
     macht das Layout schmutzig, und die naechste Hoehenabfrage laesst den
     Browser die ganze Seite neu rechnen. */
  $$('.rv,.rv-l,.rv-r,.rv-s').forEach(function(el){
    if(el.classList.contains('zerlegt') || el.tagName === 'FIGURE') return;
    if(el.offsetHeight < h * 0.55) return;
    var kinder = $$(':scope > *', el).filter(function(c){
      return c.offsetHeight > 4 && !c.classList.contains('teil');
    });
    if(kinder.length > 1) fund.push([el, kinder]);
  });
  fund.forEach(function(f){
    f[0].classList.add('zerlegt');
    f[0].classList.add('on');     /* faellt damit aus revEls heraus */
    f[1].forEach(function(c){ c.classList.add('rv-k'); });
  });
}
/* Alles im Abschnitt laeuft ein, nicht nur ein Teil.

   Tim 01.10.2026: „beim Scrollen … dass auch jede Animation flüssig ist und
   nicht schon Sachen davor dran stehen". Bisher trugen nur Dachzeile,
   Ueberschrift und einzelne Karten eine Einblendung; Absaetze, Knoepfe,
   Kachelraster und Wischreihen standen schon da, waehrend daneben etwas
   einlief. Hier bekommt jedes sichtbare Blatt eines Abschnitts, das noch
   keine eigene Bewegung hat, ein .rv — ohne Doppelungen: hat ein Element
   bewegte Nachfahren, wird nur in seine Kinder abgestiegen. Was beim Laden
   schon im Bild steht, bleibt unangetastet (sonst verschwaende es kurz). */
var REV_SEL = '.rv,.rv-l,.rv-r,.rv-s,.rv-c,.rv-k,.rv-p,.zl,.marke,.teil,.gras,[data-zahl]';
/* Raster werden nicht als Ganzes eingeblendet, sondern Karte fuer Karte —
   so laeuft eine Welle durch die Reihe statt eines Blocks. */
var REV_RASTER = '.raster,.wisch-m,.kacheln,.katkacheln,.r2,.r3,.r4,.impr,.personen,.partner,.such-rat-liste';
function autoEinblenden(){
  var h = W.innerHeight;
  function markieren(el){
    Array.prototype.forEach.call(el.children, function(c){
      if(c.matches(REV_SEL) || c.matches('script,style,template,input,.mo,[hidden]')) return;
      var cs = W.getComputedStyle(c);
      if(cs.display === 'none' || cs.position === 'sticky' || cs.position === 'fixed' ||
         cs.position === 'absolute') return;
      if(c.querySelector(REV_SEL) || c.matches(REV_RASTER)){ markieren(c); return; }
      if(c.getBoundingClientRect().top < h) return;
      /* Produkte gleiten in ihrer Reihe herein, Bilder zoomen leicht auf,
         alles andere steigt auf. */
      if(c.matches('.prod,.kachel,.katkachel')) c.classList.add('rv-p');
      else if(c.matches('figure,picture,img,.lageplan')) c.classList.add('rv-s');
      else c.classList.add('rv');
    });
  }
  $$('main .band .wrap').forEach(markieren);
}
function revSammeln(){
  revEls = $$('.rv,.rv-l,.rv-r,.rv-s,.rv-c,.rv-k,.rv-p,.zl,.marke,.gras.wachs,[data-zahl]')
    .filter(function(e){ return !e.classList.contains('on'); });
}
function revPruefen(){
  if(!revBereit) return;
  var h = W.innerHeight, uebrig = [], staffel = 0;
  revEls.forEach(function(el){
    var r = el.getBoundingClientRect();
    /* Nur die Oberkante zaehlt. Mit einer zusaetzlichen Unterkanten-Bedingung
       bleibt ein Element, das schneller nach oben aus dem Bild laeuft, als
       sein Verzoegerungswert braucht, dauerhaft unsichtbar — genau das ist
       beim schnellen Durchscrollen den Bewertungskarten passiert. */
    /* Zahlen, die hochlaufen, brauchen eine strengere Schwelle: das
       Zahlenband sitzt direkt unter dem Seitenkopf und lag damit schon beim
       Laden innerhalb der 90 %. Der Zaehler lief los, bevor jemand ihn sehen
       konnte, und war vorbei, wenn man ankam. */
    /* Nur die Zahl selbst wartet (0,75), nicht mehr der ganze Block um sie
       herum: das Bewertungsband erschien sonst erst, wenn es schon zur Haelfte
       im Bild stand — beim Scrollen sah man eine leere Flaeche (Tim
       30.09.2026: „kommt das voll spät mit dem rating die animation"). */
    var schwelle = el.hasAttribute('data-zahl') ? 0.75 : 0.92;
    if(r.top < h * schwelle){
      /* Die Staffelung ist nur sinnvoll, solange das Element von unten
         hereinkommt. Ist es beim schnellen Scrollen schon oben aus dem
         Bild, wird sofort aufgedeckt — sonst haengt die Sichtbarkeit an
         einem Timer, der ins Leere laeuft. */
      var v = +(el.getAttribute('data-v') || 0);
      /* Die Staffelung ist fuer nebeneinanderliegende Kacheln auf dem
         Desktop gedacht. Auf dem Handy stehen dieselben Kacheln jetzt zu
         zweit in einer Reihe und ein Wert wie 270 ms laesst die letzte
         sichtbar hinterherhinken — das liest sich als Ruckeln, nicht als
         Rhythmus. Deshalb hier gedeckelt. */
      if(W.innerWidth <= 699) v = Math.min(v, 90);
      /* Kommen mehrere Elemente im selben Augenblick ins Bild, laufen sie
         nacheinander ein (je 60 ms, hoechstens 240) — eine Welle statt eines
         Blocks. Nur fuer Elemente, die gerade von unten hereinkommen. */
      if(!v && r.top > 0){ v = Math.min(staffel * 60, 240); staffel++; }
      if(v && r.bottom > 0) setTimeout(function(){ anmachen(el); }, v);
      else anmachen(el);
    } else uebrig.push(el);
  });
  revEls = uebrig;
}
function anmachen(el){
  el.classList.add('on');
  if(el.hasAttribute('data-zahl')) zaehlen(el);
}

/* Zahlen laufen hoch, sobald sie ins Bild kommen */
function zaehlen(el){
  /* data-zahl steht in deutscher Schreibweise ("4,5"). parseFloat bricht
     am Komma ab und liefert 4 — der Zaehler bliebe bei "4,0" stehen. */
  var roh  = el.getAttribute('data-zahl'),
      ziel = parseFloat(roh.replace(',', '.')),
      dez  = (roh.split(',')[1] || '').length,
      pre  = el.getAttribute('data-pre') || '',
      post = el.getAttribute('data-post') || '';
  /* Ohne useGrouping:false macht toLocaleString aus der Jahreszahl 1991
     ein "1.991". Keine der Kennzahlen hier braucht Tausenderpunkte. */
  var FORM = {minimumFractionDigits:dez, maximumFractionDigits:dez, useGrouping:false};
  if(flau){ el.textContent = pre + ziel.toLocaleString('de-DE', FORM) + post; return; }
  var t0 = null, dauer = 1500;
  function schritt(t){
    if(t0 === null) t0 = t;
    var p = Math.min(1, (t - t0) / dauer);
    var e = 1 - Math.pow(1 - p, 3);
    el.textContent = pre + (ziel * e).toLocaleString('de-DE', FORM) + post;
    if(p < 1) requestAnimationFrame(schritt);
  }
  requestAnimationFrame(schritt);
}

/* ====================== Kopfleiste + Fortschritt ================ */
var kopf = $('#kopf');
/* Ein Durchlauf je Bild, nicht je Scrollereignis.

   Der Browser feuert `scroll` oefter, als er malt. Jeder Durchlauf hier
   liest Rechtecke und schreibt Stile — abwechselnd, was den Browser jedes
   Mal neu rechnen laesst. Mit der Bildsperre passiert das genau einmal je
   dargestelltem Bild. */
var scrollWartet = false;
function beimScrollen(){
  if(scrollWartet) return;
  scrollWartet = true;
  W.requestAnimationFrame(function(){ scrollWartet = false; scrollRechnen(); });
}
function scrollRechnen(){
  ketteScrollen();
  var y = W.scrollY || doc.documentElement.scrollTop;
  /* Die Kopfleiste bleibt beim Scrollen stehen. Sie beim Runterscrollen
     wegzufahren hiesse, den Wanderer auf der Fortschrittslinie genau dann
     auszublenden, wenn er laeuft — der Fortschritt ist hier das Motiv. */
  if(kopf) kopf.classList.toggle('fest', y > 12);
  var hoch = doc.documentElement.scrollHeight - W.innerHeight;
  var p = hoch > 0 ? Math.min(1, y / hoch) : 0;
  /* Parallaxe im Hero-Motiv, nur solange es im Bild ist */
  /* Die drei Elemente einmal merken statt bei jedem Bild neu suchen; die
     Breite der Laufbahn dazu. Prozente gehen hier nicht: in `left` bezogen
     sie sich auf die Leiste, in `transform` wuerden sie sich auf die 21 px
     des Wanderers beziehen. */
  if(sMotiv === undefined) leisteMerken();
  if(sMotiv && !flau && y < 1100) sMotiv.style.setProperty('--par', (y * 0.055).toFixed(2));
  if(sVoll)  sVoll.style.setProperty('--p', p.toFixed(4));
  /* Der Versatz haelt den Wanderer an beiden Enden vollstaendig im Bild:
     bei 0 % steht er auf seiner halben Breite, bei 100 % entsprechend davor. */
  if(sGeher) sGeher.style.setProperty('--x',
      (p * sBahn + (0.5 - p) * 21).toFixed(1) + 'px');
  revPruefen();
}
var sMotiv, sVoll, sGeher, sBahn = 0;
function leisteMerken(){
  sMotiv = $('.motiv-svg'); sVoll = $('#fs-voll'); sGeher = $('#fs-geher');
  sBahn = sGeher ? (sGeher.parentNode.clientWidth || W.innerWidth) : 0;
}

/* ====================== Menü und Overlays ====================== */
function auf(el){
  if(!el) return;
  el.classList.add('an');
  /* Die Sperre gehoert an das Wurzelelement. Solange der <body>
     overflow-x:hidden trug, war er selbst der Scrollbereich und
     overflow:hidden auf ihm hat gereicht. Seit er nur noch clippt
     (sonst waeren die letzten 100px der Seite unerreichbar), scrollt
     der Viewport ueber <html> — dort muss die Sperre hin. */
  doc.documentElement.style.overflow = 'hidden';
  doc.body.style.overflow = 'hidden';
  el._von = doc.activeElement;
  var f = el.querySelector('a,button');
  if(f) setTimeout(function(){ f.focus(); }, 60);
}
function zu(el){
  if(!el) return;
  el.classList.remove('an');
  if(!$('.mnu.an') && !$('.mo.an') && !$('.korb.an')){
    doc.documentElement.style.overflow = '';
    doc.body.style.overflow = '';
  }
  /* Tastatur: Fokus zurueck auf den Knopf, der geoeffnet hat (WCAG 2.4.3) */
  if(el.id === 'mnu'){ var m = $('#menue-auf'); if(m) m.setAttribute('aria-expanded','false'); }
  if(el._von && el._von.focus){ el._von.focus(); el._von = null; }
}
/* Fokusfalle: Tab bleibt im offenen Overlay, sonst landet man hinter dem
   abgedunkelten Grund (WCAG 2.4.3, Barrierefreiheit 28.10.2026). Gilt auch
   fuer die Warenkorb-Schublade aus huette-shop.js. */
doc.addEventListener('keydown', function(e){
  if(e.key !== 'Tab') return;
  var offen = $$('.mo.an,.mnu.an,.korb.an'), o = offen[offen.length - 1];
  if(!o) return;
  var f = Array.prototype.filter.call(
    o.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])'),
    function(x){ return x.offsetWidth || x.offsetHeight || x.getClientRects().length; });
  if(!f.length) return;
  var erst = f[0], letzt = f[f.length - 1], akt = doc.activeElement;
  if(!o.contains(akt)){ e.preventDefault(); erst.focus(); }
  else if(e.shiftKey && akt === erst){ e.preventDefault(); letzt.focus(); }
  else if(!e.shiftKey && akt === letzt){ e.preventDefault(); erst.focus(); }
});
function overlaysVerdrahten(){
  $$('[data-mo]').forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault(); auf($('#' + a.getAttribute('data-mo')));
    });
  });
  $$('[data-zu]').forEach(function(b){
    b.addEventListener('click', function(){ zu(b.closest('.mo,.mnu,.korb')); });
  });
  doc.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ $$('.mo.an,.mnu.an,.korb.an').forEach(zu); }
  });
  var mAuf = $('#menue-auf');
  if(mAuf) mAuf.addEventListener('click', function(){
    auf($('#mnu')); mAuf.setAttribute('aria-expanded','true');
  });
}

/* ====================== Wischreihen (Handy) ==================== */
function wischVerdrahten(){
  $$('.wisch,.wisch-m,.impr').forEach(function(reihe){
    var punkte = reihe.parentNode.querySelector('.punkte');
    if(!punkte) return;
    /* Ein Punkt je Wischstellung — nicht je Karte.

       Zwei Gruende: Die Empfehlungsreihe der Startseite rendert fuenf
       Artikel und blendet den fuenften auf dem Handy per CSS aus; ein
       Punkt fuer eine unsichtbare Karte liesse sich nie erreichen. Und
       dort stehen zwei Karten uebereinander in einer Spalte — vier Punkte
       fuer zwei Wischstellungen hiessen, dass zwei nie aufleuchten: der
       Vergleich unten sucht das Element, das der Mitte am naechsten liegt,
       und bei gleichem Abstand gewinnt immer dasselbe.

       Eine Spalte erkennt man an der gemeinsamen linken Kante. Bei den
       einreihigen Wischleisten (Bewertungen, Impressionen) ist jede Karte
       ihre eigene Spalte — dort aendert sich nichts. */
    var spalten = [];
    /* offsetWidth statt getComputedStyle: ausgeblendete Karten sind 0 breit,
       und die Breite wird ohnehin gebraucht. getComputedStyle erzwang je
       Karte zusaetzlich eine Stilberechnung — auf der Startseite kostete
       das Verdrahten der drei Leisten dadurch 21 der 60 ms, die der Aufbau
       auf einem gedrosselten Prozessor insgesamt brauchte. */
    Array.prototype.slice.call(reihe.children).forEach(function(k){
      var b = k.offsetWidth;
      if(!b) return;
      var x = k.offsetLeft;
      for(var i = 0; i < spalten.length; i++){
        if(Math.abs(spalten[i].x - x) < 2) return;
      }
      spalten.push({x:x, mitte:x + b / 2});
    });
    /* Nach Lage sortieren, nicht nach Reihenfolge im Quelltext. In der
       Bewertungsleiste steht die dritte Karte ganz links (eine Rasterregel
       fuer gestapelte Karten setzt der letzten grid-column:1). Ungeordnet
       leuchtete beim Ankommen der dritte Punkt und der erste nie. */
    spalten.sort(function(a,b){ return a.x - b.x; });
    if(!spalten.length) return;
    punkte.innerHTML = spalten.map(function(_,i){
      return '<i' + (i === 0 ? ' class="an"' : '') + '></i>';
    }).join('');
    var ps = Array.prototype.slice.call(punkte.children);
    reihe.addEventListener('scroll', function(){
      var mitte = reihe.scrollLeft + reihe.clientWidth / 2, nah = 0, best = 1e9;
      spalten.forEach(function(sp,i){
        var d = Math.abs(sp.mitte - mitte);
        if(d < best){ best = d; nah = i; }
      });
      ps.forEach(function(p,i){ p.classList.toggle('an', i === nah); });
    }, {passive:true});
    /* Auto-Nudge: einmal antippen, damit man erkennt, dass es weitergeht */
    if(!flau && reihe.scrollWidth > reihe.clientWidth + 20){
      var schon = false;
      var beob = function(){
        var r = reihe.getBoundingClientRect();
        if(!schon && r.top < W.innerHeight * 0.75 && r.bottom > 0){
          schon = true;
          reihe.scrollTo({left:26, behavior:'smooth'});
          setTimeout(function(){ reihe.scrollTo({left:0, behavior:'smooth'}); }, 620);
          W.removeEventListener('scroll', beob);
        }
      };
      W.addEventListener('scroll', beob, {passive:true}); beob();
    }
  });
}

/* =============== Ratgeber: Schiene, die nicht ins Fenster passt =========
   Ein klebendes Element, das hoeher ist als sein Platz, bleibt mit dem
   OBEREN Rand haengen — der untere Teil ist dann nie zu sehen. Auf der
   Blasen-Seite sind das 1072 px Inhalt bei 646 px Platz, also 426 px, die
   niemand zu Gesicht bekommt.

   Der Ausweg ist der umgekehrte Anker: passt die Schiene nicht, klebt sie
   mit dem unteren Rand. `top` bekommt dafuer Fensterhoehe minus
   Schienenhoehe minus Luft — ein negativer Wert. Beim Herunterscrollen
   laeuft die Schiene dann so weit mit, bis ihr Fuss unten ankommt, und
   bleibt erst dort stehen. Am Anfang des Beitrags sieht man ihren Kopf,
   weiter unten ihren Fuss; alles ist erreichbar, ohne ein zweites
   Scrollfeld mit unsichtbarer Bildlaufleiste.

   Unter 1080 px Fensterbreite gibt es keine Schiene (display:contents),
   dort bleibt das Feld leer. */
var LUFT_SCHIENE = 22;
function schieneSetzen(){
  var r = $('.rt-rail');
  if(!r) return;
  if(W.innerWidth < 1080){ r.style.top = ''; return; }
  var kopf = parseFloat(W.getComputedStyle(doc.documentElement)
               .getPropertyValue('--kopf-h')) || 0;
  var oben = kopf + LUFT_SCHIENE;
  var hoch = r.offsetHeight;
  if(hoch + oben + LUFT_SCHIENE <= W.innerHeight){ r.style.top = ''; return; }
  r.style.top = Math.round(W.innerHeight - hoch - LUFT_SCHIENE) + 'px';
}

/* ====================== Ratgeber: Sprungmenue ================== */
/* Ein Ratgeber wird suchend gelesen, nicht von vorn. Das Menue entsteht aus
   den Abschnitten des Beitrags selbst — so bekommt es jeder kuenftige
   Beitrag, ohne dass jemand es pflegt. Unter drei Abschnitten bleibt es
   weg; fuer zwei Sprungmarken lohnt kein Kasten. */
/* Symbole an den Abschnitten eines Ratgeberbeitrags. Sie stehen als
   data-icon im Beitragstext, nicht als fertiges <svg>: Wer den Beitrag im
   Adminbereich im Rich-Text-Editor oeffnet, verliert eingebettete
   SVG-Elemente — ein Attribut ueberlebt das. Gezeichnet wird aus demselben
   Symbolvorrat wie der Rest der Seite, also ohne zweite Quelle.
   Laeuft getrennt vom Sprungmenue: das steigt unter drei Abschnitten aus,
   die Symbole sollen trotzdem da sein. */
function symboleSetzen(){
  var NS = 'http://www.w3.org/2000/svg';
  $$('.rt-rte [data-icon]').forEach(function(z){
    var name = z.getAttribute('data-icon');
    if(!name || z.querySelector('.rt-sym')) return;
    var s = doc.createElementNS(NS, 'svg');
    s.setAttribute('class', 'rt-sym');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    var u = doc.createElementNS(NS, 'use');
    u.setAttribute('href', '#i-' + name);
    s.appendChild(u);
    z.insertBefore(s, z.firstChild);
  });
}

/* Leiste „passende Artikel ansehen" (Ratgeber, unter 1080px). Sichtbar ab
   dem zweiten Bildschirm, weg sobald das Raster selbst im Bild ist. */
function leisteVerdrahten(){
  var leiste = $('[data-rt-leiste]'), ziel = $('#rt-produkte');
  if(!leiste || !ziel) return;
  var zielSichtbar = false;
  function schalten(){
    leiste.hidden = zielSichtbar || W.scrollY < W.innerHeight * 0.9;
  }
  if('IntersectionObserver' in W){
    new IntersectionObserver(function(e){
      zielSichtbar = e[0].isIntersecting; schalten();
    }).observe(ziel);
  }
  W.addEventListener('scroll', schalten, {passive:true});
  schalten();
}

function inhaltVerdrahten(){
  leisteVerdrahten();
  symboleSetzen();
  var kasten = $('[data-rt-inhalt]');
  if(!kasten) return;
  var ziele = $$('.rt-rte h2[id], .rt-rte .rt-tipp[id]');
  if(ziele.length < 3) return;
  var liste = kasten.querySelector('.rt-inhalt-liste');
  ziele.forEach(function(z){
    var kopf = z.querySelector('.rt-tipp-kopf');
    var name = z.getAttribute('data-kurz') ||
               (kopf ? kopf.textContent : z.textContent);
    var a = doc.createElement('a');
    a.href = '#' + z.id;
    a.textContent = name.trim();
    liste.appendChild(a);
  });
  kasten.removeAttribute('hidden');
}

/* ====================== Formulare ============================== */
/* Das Kontaktformular geht jetzt echt an Shopify. Hier bleibt nur der
   Honigtopf: ist das versteckte Feld ausgefuellt, war es kein Mensch —
   dann wird nicht abgeschickt. Sonst laeuft das Formular normal durch. */
function formulareVerdrahten(){
  $$('form .hp input').forEach(function(feld){
    var f = feld.form; if(!f) return;
    f.addEventListener('submit', function(e){
      if(feld.value) e.preventDefault();
    });
  });
}

/* ====================== Einwilligung ============================
   Setzt die Entscheidung ueber Shopifys Customer-Privacy-API. Damit gilt sie
   fuer Shopifys eigene Analyse, fuer spaeter eingebundene Dienste und fuer
   die Karte im Kontaktbereich — an einer Stelle gepflegt, nicht an dreien.

   Das Banner erscheint nur, wenn noch keine Entscheidung vorliegt. Hat
   Shopify fuer die Region gar keine Zustimmungspflicht hinterlegt, meldet
   die API "erlaubt" und das Banner bleibt weg. */
function ccApi(){ return W.Shopify && W.Shopify.customerPrivacy; }

/* Die Entscheidung merkt sich Shopify in seinem Zustimmungs-Cookie. Meldet
   die API einen Fehler — oder laedt sie gar nicht erst —, wusste die Seite
   davon nichts und fragte bei jedem Seitenwechsel erneut. Deshalb liegt die
   Entscheidung zusaetzlich hier im Geraet.

   Geschrieben wird sie erst beim Klick, nicht beim Seitenaufruf: ein
   Speicherzugriff schon vor der Entscheidung waere genau das, was § 25 TDDDG
   verbietet. Gespeichert ist nur die Wahl selbst, keine Kennung. */
var CC_SPEICHER = 'huette-cc';

function ccMerken(analyse, marketing){
  try {
    W.localStorage.setItem(CC_SPEICHER, JSON.stringify(
      {analyse: !!analyse, marketing: !!marketing, stand: 1}));
  } catch(e){ /* privater Modus o.ae. — dann entscheidet allein Shopify */ }
}

function ccGemerkt(){
  try {
    var r = W.localStorage.getItem(CC_SPEICHER);
    if(!r) return null;
    var d = JSON.parse(r);
    return (d && d.stand === 1) ? d : null;
  } catch(e){ return null; }
}

function ccAnShopify(analyse, marketing, fertig){
  var p = ccApi();
  if(!p || !p.setTrackingConsent){ if(fertig) fertig(); return; }
  p.setTrackingConsent({
    analytics:   !!analyse,
    marketing:   !!marketing,
    preferences: !!marketing,
    sale_of_data: false
  }, function(){ if(fertig) fertig(); });
}

function ccSetzen(analyse, marketing){
  ccMerken(analyse, marketing);
  /* Der Kasten geht sofort zu. Frueher wartete er auf die Rueckmeldung der
     API — kam die nie, blieb er stehen und der Klick wirkte wirkungslos. */
  var k = doc.getElementById('cc');     if(k) k.hidden = true;
  var n = doc.getElementById('cc-neu'); if(n) n.hidden = false;
  ccAnShopify(analyse, marketing);
  /* Die Karte haengt an derselben Entscheidung. Ohne diesen Aufruf erschien
     sie erst nach dem naechsten Seitenwechsel — Shopify meldet die neue Wahl
     zwar per Ereignis, aber nur wenn die API ueberhaupt geladen hat. */
  if(marketing && typeof karteLaden === 'function') karteLaden();
}

function ccVerdrahten(){
  var kasten = doc.getElementById('cc');
  if(!kasten) return;
  var wahl  = doc.getElementById('cc-wahl');
  var neu   = doc.getElementById('cc-neu');
  var spei  = kasten.querySelector('[data-cc="speichern"]');
  var oeffn = kasten.querySelector('[data-cc="wahl"]');

  function zeigen(){ kasten.hidden = false; if(neu) neu.hidden = true; }

  kasten.addEventListener('click', function(e){
    var b = e.target.closest('[data-cc]'); if(!b) return;
    var w = b.getAttribute('data-cc');
    if(w === 'alle')  return ccSetzen(true, true);
    if(w === 'keine') return ccSetzen(false, false);
    if(w === 'wahl'){                    // Einstellungen aufklappen
      wahl.hidden = false; oeffn.hidden = true; spei.hidden = false; return;
    }
    if(w === 'speichern'){
      return ccSetzen(doc.getElementById('cc-analyse').checked,
                      doc.getElementById('cc-marketing').checked);
    }
  });
  if(neu) neu.addEventListener('click', zeigen);

  /* Widerruf der Einwilligung muss so leicht sein wie die Erteilung
     (Art. 7 Abs. 3 DSGVO). Neben dem Symbol unten links oeffnet deshalb auch
     der Textlink „Cookie-Einstellungen" in der Fusszeile denselben Kasten. */
  doc.addEventListener('click', function(e){
    var l = e.target.closest('[data-cc="oeffnen"]');
    if(!l) return;
    e.preventDefault();
    zeigen();
    if(wahl && oeffn && spei){ wahl.hidden = false; oeffn.hidden = true; spei.hidden = false; }
    var erste = kasten.querySelector('button, [href], input');
    if(erste) erste.focus();
  });

  var gemeldet = false;
  function pruefen(){
    /* Liegt hier eine Entscheidung, wird nicht noch einmal gefragt — sie
       wird nur erneut an Shopify gemeldet, damit die Messung dem entspricht,
       was der Besucher gewaehlt hat. Nur einmal je Seitenaufruf: Shopify
       feuert nach jedem setTrackingConsent erneut visitorConsentCollected,
       ohne diese Sperre lief das als Endlosschleife (Pruefung 05.10.2026). */
    var g = ccGemerkt();
    if(g){
      if(neu) neu.hidden = false;
      kasten.hidden = true;
      if(!gemeldet){ gemeldet = true; ccAnShopify(g.analyse, g.marketing); }
      return;
    }
    var p = ccApi(); if(!p) return;
    /* shouldShowBanner() ist wahr, solange keine Entscheidung vorliegt UND
       die Region eine verlangt. */
    if(p.shouldShowBanner && p.shouldShowBanner()) zeigen();
    else if(neu) neu.hidden = false;
  }
  doc.addEventListener('visitorConsentCollected', pruefen);
  if(ccGemerkt()){ if(neu) neu.hidden = false; }
  if(ccApi()) return pruefen();
  if(W.Shopify && W.Shopify.loadFeatures){
    W.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], function(err){
      pruefen();
      if(err && !ccGemerkt()) zeigen();   /* API weg: lieber fragen als messen */
    });
  } else if(!ccGemerkt()){
    zeigen();
  }
}

/* ====================== Chronologie: Kette waechst mit ===========
   Die gruene Linie folgt dem Scrollen, und jeder Punkt faerbt sich in dem
   Moment, in dem die Linie ihn erreicht. Vorher blendete jede Stufe fuer
   sich ein; kamen mehrere zusammen ins Bild, sprangen sie gleichzeitig auf
   und das wirkte unruhig.

   Bezugslinie ist nicht die Fenstermitte, sondern 62 % der Fensterhoehe:
   dort liest man, und der Punkt soll angehen, bevor man den Text erreicht,
   nicht danach. */
var kette = null, kettePunkte = [];
function ketteVerdrahten(){
  kette = $('.strahl');
  if(!kette) return;
  kettePunkte = $$('.stufe', kette);
  if(flau){
    kette.style.setProperty('--fuell', 1);
    kettePunkte.forEach(function(s){ s.classList.add('wach'); });
    kette = null;
  }
}
function ketteScrollen(){
  if(!kette) return;
  var r = kette.getBoundingClientRect();
  var linie = W.innerHeight * 0.62;
  /* Anteil der Kette, der oberhalb der Bezugslinie liegt. */
  var p = (linie - r.top) / r.height;
  p = Math.max(0, Math.min(1, p));
  kette.style.setProperty('--fuell', p.toFixed(4));
  var y = r.top + r.height * p;              // Bildpunkt der Spitze
  kettePunkte.forEach(function(s){
    var q = s.getBoundingClientRect();
    /* +7px: der Punkt sitzt sieben Pixel unter der Oberkante der Stufe. */
    s.classList.toggle('wach', y >= q.top + 7);
  });
}

/* ====================== Gutschein: Betrag waehlen ================
   Shopify kennt fuer Gutscheine nur feste Varianten. Die Auswahlliste ist
   deshalb die Wahrheit — sie traegt die IDs und wird abgeschickt. Das
   Zaehlfeld ist nur die Bedienung davor: tippen oder mit + und − springen,
   immer in Fuenferschritten. Ohne JavaScript bleibt die Liste sichtbar und
   der Kauf geht genauso. */
/* Eroeffnungsrabatt: der Knopf neben dem Code kopiert ihn. Ohne Clipboard-
   Schnittstelle (alte Browser, kein HTTPS) bleibt der Code einfach lesbar. */
function rabattVerdrahten(){
  /* Zweite Sicherung neben dem Liquid-Zeitvergleich: liefert Shopify nach
     Ablauf noch eine zwischengespeicherte Seite aus, verschwindet die Marke
     trotzdem im Browser. */
  Array.prototype.forEach.call(doc.querySelectorAll('[data-rabatt-ende]'), function(m){
    if(Date.now() / 1000 > parseInt(m.getAttribute('data-rabatt-ende'), 10)) m.remove();
  });
  Array.prototype.forEach.call(doc.querySelectorAll('[data-kopieren]'), function(b){
    b.addEventListener('click', function(){
      if(!navigator.clipboard) return;
      navigator.clipboard.writeText(b.getAttribute('data-kopieren')).then(function(){
        var t = $('[data-kopiert-txt]', b), box = b.closest('.hero-rabatt') || b;
        box.classList.add('kopiert');
        if(t) t.textContent = 'Kopiert';
        setTimeout(function(){ box.classList.remove('kopiert'); if(t) t.textContent = 'Kopieren'; }, 2400);
      });
    });
  });
}

function gutscheinVerdrahten(){
  var f = doc.getElementById('gutschein-form');
  if(!f) return;
  var sel   = $('[data-gs-select]', f);
  var feld  = $('[data-gs-eingabe]', f);
  var zaehl = $('[data-gs-zaehler]', f);
  var liste = $('[data-gs-liste]', f);
  var summe = $('[data-gs-summe]', f);
  var karte = $('[data-gs-ticket]');
  if(!sel || !feld) return;

  /* Betrag -> Option. Die Werte stehen am Markup, damit hier nichts
     gerechnet und nichts geraten wird. */
  var werte = [];
  var nachWert = {};
  Array.prototype.forEach.call(sel.options, function(o){
    var w = parseInt(o.getAttribute('data-wert'), 10);
    if(!isNaN(w)){ werte.push(w); nachWert[w] = o; }
  });
  if(!werte.length) return;
  werte.sort(function(a,b){ return a-b; });
  var min = werte[0], max = werte[werte.length-1];

  function naechster(w){
    /* Auf den naechstgelegenen vorhandenen Betrag runden — getippte
       Zwischenwerte sollen nicht ins Leere laufen. */
    var best = werte[0], ab = Math.abs(w - best);
    for(var i=1;i<werte.length;i++){
      var d = Math.abs(w - werte[i]);
      if(d < ab){ ab = d; best = werte[i]; }
    }
    return best;
  }

  function setzen(w, tippen){
    w = naechster(Math.min(max, Math.max(min, w)));
    nachWert[w].selected = true;
    if(!tippen) feld.value = w;
    /* Ganze Euro, deutsche Schreibweise — die Betraege haben nie Cent. */
    if(summe) summe.textContent = w.toLocaleString('de-DE') + ',00 €';
    /* Der gezeichnete Gutschein traegt denselben Betrag — sonst zeigt das
       Bild dauerhaft die 50 aus dem Markup. */
    if(karte) karte.textContent = w.toLocaleString('de-DE');
    Array.prototype.forEach.call(f.querySelectorAll('[data-gs-wert]'), function(b){
      b.classList.toggle('an', parseInt(b.getAttribute('data-gs-wert'),10) === w);
    });
  }

  var stufe = parseInt(f.getAttribute('data-schritt'), 10) || 5;
  $('[data-gs-minus]', f).addEventListener('click', function(){
    setzen((parseInt(feld.value,10) || min) - stufe);
  });
  $('[data-gs-plus]', f).addEventListener('click', function(){
    setzen((parseInt(feld.value,10) || min) + stufe);
  });
  feld.addEventListener('input', function(){
    var w = parseInt(feld.value, 10);
    if(!isNaN(w)) setzen(w, true);
  });
  feld.addEventListener('blur', function(){ setzen(parseInt(feld.value,10) || min); });
  f.addEventListener('click', function(e){
    var b = e.target.closest('[data-gs-wert]');
    if(b) setzen(parseInt(b.getAttribute('data-gs-wert'), 10));
  });

  /* Erst jetzt umschalten: bis hierher war die Liste bedienbar. */
  if(zaehl) zaehl.hidden = false;
  if(liste) liste.hidden = true;
  setzen(parseInt(feld.value, 10) || 50);

  /* Empfaenger: der Haken schaltet die Felder frei. Gesperrt werden sie
     weder geprueft noch mitgeschickt. */
  var empfKasten = $('[data-gs-empf-kasten]', f);
  var empfAn = $('[data-gs-empf-an]', f);
  var empf = $('[data-gs-empf]', f);
  if(empfKasten && empfAn && empf){
    empfKasten.hidden = false;
    empfAn.addEventListener('change', function(){
      empf.hidden = empf.disabled = !empfAn.checked;
    });
  }
}

/* ====================== Karte nach Einwilligung ==================
   Die Karte soll ohne zweiten Klick da sein — aber erst, wenn eingewilligt
   wurde. Eine eingebettete Google-Karte uebertraegt die IP-Adresse des
   Besuchers, und das ist vorher nicht zulaessig (§ 25 TDDDG).

   Shopify liefert den Einwilligungsstand ueber die Customer-Privacy-API.
   Liegt sie vor: sofort laden. Wird spaeter zugestimmt, feuert
   visitorConsentCollected und die Karte erscheint nach — ohne Neuladen.
   Ist gar kein Banner eingerichtet, meldet Shopify "erlaubt". Ohne API
   bleibt es beim Platzhalter mit Routen-Knopf; der geht immer. */
function karteLaden(){
  var k = doc.getElementById('lageplan');
  if(!k || k.classList.contains('geladen')) return;
  var rahmen = doc.createElement('iframe');
  rahmen.src = k.getAttribute('data-karte');
  rahmen.loading = 'lazy';
  rahmen.title = 'Lageplan: Die Hütte, Bautzner Straße 39, Dresden';
  rahmen.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
  rahmen.setAttribute('allowfullscreen', '');
  k.insertBefore(rahmen, k.firstChild);
  k.classList.add('geladen');
}

function karteVerdrahten(){
  if(!doc.getElementById('lageplan')) return;
  var P = W.Shopify && W.Shopify.customerPrivacy;
  function pruefen(){
    /* Die eigene Notiz zaehlt zuerst: wer "Alle annehmen" geklickt hat, soll
       die Karte auch dann sehen, wenn die Shopify-API gerade nicht antwortet.
       Ohne beides bleibt es beim Platzhalter — nie umgekehrt. */
    var g = ccGemerkt();
    if(g && g.marketing) karteLaden();
    /* Kein Rueckgriff auf Shopifys Freigabe mehr: analyticsProcessingAllowed()
       meldet ohne eingestelltes Pflichtgebiet "erlaubt" und ist obendrein die
       Analyse-, nicht die Karten-Einwilligung. Die Karte laedt nur nach
       ausdruecklichem „Karte" im eigenen Kasten
       (Rechtspruefung 29.09.2026, § 25 TDDDG). */
  }
  doc.addEventListener('visitorConsentCollected', pruefen);
  if(P){ pruefen(); return; }
  if(W.Shopify && W.Shopify.loadFeatures){
    W.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], function(err){
      if(!err) pruefen();
    });
  }
}

/* ====================== Intro nach dem Gate ==================== */
function startIntro(){
  if (!location.hash) W.scrollTo(0, 0);
  doc.body.classList.add('los');
  revSammeln();
  revPruefen();
  statusSetzen();
  korbBadge();

  /* Die Ueberschriften werden ERST geteilt, wenn die Hausschriften stehen.
     Vorher wurde zweimal geteilt: einmal sofort mit den Massen der
     Ersatzschrift, einmal nach dem Nachladen. Wenn die erste Teilung eine
     Zeile mehr ergab als die zweite, sprang die halbe Seite — gemessen auf
     1024x768 ein CLS von 0,278, und zwar in etwa jedem dritten Aufruf.
     Wer das nicht erwischt, sieht nichts; wer es erwischt, sieht die Seite
     zucken. Beides ist schlecht.

     Bis die Schriften da sind, steht die Ueberschrift als normaler Text —
     lesbar, nur ohne die Zeilenanimation. Kommt keine Antwort, wird nach
     1,2 Sekunden trotzdem geteilt, damit die Animation nicht ausfaellt. */
  /* Sofort teilen, mit der Ersatzschrift — und erst NACHTRAEGLICH auf die
     Hausschrift nachschaerfen.

     Vorher wartete die Ueberschrift auf die Schrift, Ueberzeile und Anriss
     nicht: gemessen 113 ms gegen 2150 ms. Zwei Sekunden Abstand, und genau
     das las sich als zweites Aufploppen beim Wechsel auf eine Unterseite.

     Warum das Nachschaerfen noetig bleibt: die massgleiche Ersatzschrift
     trifft nicht ganz. Bei 1 von 22 Ueberschriften ergibt sie eine andere
     Zeilenaufteilung — mit der breiteren Hausschrift passt eine Zeile dann
     nicht mehr in ihr Feld, und `.zl{overflow:hidden}` schneidet sie
     seitlich ab. Deshalb wird nach dem Laden der Schrift neu geteilt, und
     zwar mit abgeschalteten Uebergaengen, also unsichtbar. */
  var geteilt = false;
  function teilenUndZeigen(){
    if(geteilt) return;
    geteilt = true;
    var still = schonSichtbar();
    alleTeilen();
    if(still){
      /* `fertig` setzt den Endzustand ohne Animation — der Wechsel von
         Klartext auf Zeilen bleibt damit unsichtbar. */
      /* Nur was gerade im Bild steht. Vorher galt das fuer ALLE
         Ueberschriften der Seite — weiter unten standen sie dann beim
         Scrollen schon fertig da, waehrend Text und Karten daneben erst
         einliefen (Tim 01.10.2026: „nicht schon Sachen davor dran stehen"). */
      var hFenster = W.innerHeight;
      $$('.teil .zl').forEach(function(z){
        if(z.getBoundingClientRect().top >= hFenster) return;
        z.classList.add('on'); z.classList.add('fertig');
      });
    }
    revBereit = true;
    autoEinblenden();
    grosseZerlegen();
    revSammeln();
    /* Kein Bilder-Tanz noetig: der Einlauf ist eine Keyframe-Animation und
       startet mit der Klasse. Frueher stand hier ein erzwungener Reflow und
       zweimal requestAnimationFrame, um dem Browser den Anfangszustand
       unterzuschieben — das war der fragile Teil, siehe huette-base.css. */
    revPruefen();
    introZeit = jetzt();
  }

  teilenUndZeigen();

  /* Nur auf die EINE Schrift der Ueberschriften warten, nicht auf
     doc.fonts.ready — das wird erst fertig, wenn auch Fremdschriften aus
     eingebundenen Diensten geladen sind. */
  if(doc.fonts && doc.fonts.load){
    doc.fonts.load('700 1em Slab').then(function(){
      /* Erst wenn die Einlauf-Animation durch ist. neuTeilen schaltet fuer
         seine Dauer alle Uebergaenge ab; kommt die Schrift MITTEN in die
         Animation, kappt es sie und die Zeile springt auf ihren Platz.
         Gemessen auf 1440px im kalten Zustand: 77 px Versatz, dann 0 in
         32 ms statt der 900 ms Uebergang. */
      var rest = Math.max(0, (introZeit + INTRO_MS + 60) - jetzt());
      setTimeout(function(){
        var ab = umbruchAbweichler();
        if(ab.length) neuTeilen(ab);
      }, rest);
    }, function(){});
  }
}

/* ====================== Aufbau ================================= */
function los(){
  W.huetteLos = true;   /* sonst nimmt theme.liquid nach 5 s die js-Klasse weg, damit nichts unsichtbar bleibt */
  overlaysVerdrahten();
  wischVerdrahten();
  inhaltVerdrahten();
  formulareVerdrahten();
  ccVerdrahten();
  gutscheinVerdrahten();
  rabattVerdrahten();
  ketteVerdrahten();
  karteVerdrahten();
  schieneSetzen();
  W.addEventListener('scroll', beimScrollen, {passive:true});
  /* Neu geteilt wird nur, wenn sich die BREITE aendert — der Zeilenumbruch
     haengt an nichts anderem.

     Auf dem Handy feuert resize beim Scrollen, weil die Adressleiste ein-
     und ausfaehrt: innerHeight aendert sich, innerWidth nicht. Ohne diese
     Sperre lief bei jedem Scrollstueck alleTeilen(). Das leert die
     Ueberschrift (el.textContent = '') und baut die Zeilen als frische
     Spans ohne .on wieder auf — also bei translateY(125%), unter der
     Zeilenmaske. Das .on kommt zwar in derselben Runde zurueck, aber
     zeilenTeilen misst fuer jede weitere Ueberschrift mit offsetWidth und
     erzwingt damit ein Neuberechnen des Layouts; die vorher angehaengten
     Zeilen sind da schon gerendert, und der Uebergang laeuft sichtbar ab.
     Auf dem Handy sah man den Text deshalb beim Scrollen herausfallen und
     erneut einfahren — bei mehreren Ueberschriften nacheinander.

     Drehen aendert die Breite und teilt weiterhin neu. */
  /* documentElement.clientWidth statt innerWidth: der Wert schliesst die
     Bildlaufleiste aus und schwankt auf dem Handy nicht mit der
     Adressleiste. Und erst ab zwei Pixeln Unterschied wird neu geteilt —
     iOS meldet beim Ein- und Ausfahren der Leiste gelegentlich eine um
     einen Bruchteil abweichende Breite, und jedes Neuteilen ist ein
     sichtbarer Eingriff. */
  var letzteBreite = doc.documentElement.clientWidth;
  W.addEventListener('resize', function(){
    /* Die Schiene haengt an der FENSTERHOEHE, nicht an der Breite — sie
       muss deshalb vor der Breitensperre stehen. Sonst bliebe ihr Anker
       falsch, wenn jemand das Fenster nur hoeher oder niedriger zieht. */
    schieneSetzen();
    var jetzt = doc.documentElement.clientWidth;
    if(Math.abs(jetzt - letzteBreite) < 2) return;
    letzteBreite = jetzt;
    if(sMotiv !== undefined) leisteMerken();   /* Laufbahn ist mitgewachsen */
    clearTimeout(los._t);
    los._t = setTimeout(function(){ neuTeilen(); }, 180);
  });
  setInterval(statusSetzen, 60000);
  beimScrollen();

  if(W.SEITE_START) W.SEITE_START();

  startIntro();
}

/* Kundenstimmen am Handy: gekuerzt auf vier Zeilen, „weiterlesen" klappt
   den unveraenderten Wortlaut auf. */
doc.addEventListener('click', function(e){
  var b = e.target.closest && e.target.closest('.stimme .mehr');
  if(!b) return;
  var auf = b.closest('.stimme').classList.toggle('offen');
  b.setAttribute('aria-expanded', auf ? 'true' : 'false');
  b.textContent = auf ? 'weniger' : 'weiterlesen';
});

/* Sortiment-Tafel im Kopf (06.10.2026, Knopf-Pruefung): ein <details> schliesst
   von sich aus nur ueber seinen eigenen Reiter. Offen lag die Tafel ueber der
   Seite, bis man „Sortiment" ein zweites Mal traf. Jetzt schliessen auch
   Escape und ein Klick ausserhalb. */
doc.addEventListener('click', function(e){
  var sm = doc.getElementById('sortiment-menue');
  if(sm && sm.open && !sm.contains(e.target)) sm.open = false;
});
doc.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  var sm = doc.getElementById('sortiment-menue');
  if(sm && sm.open){ sm.open = false; var s = sm.querySelector('summary'); if(s) s.focus(); }
});

if(doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', los);
else los();
})();